module.exports = __webpack_public_path__ + "img/bg_shapes.8047c11d.png";